import type { Component } from "vue";

type UserCenterViewModule = {
  default: Component;
};

const userCenterViewLoaders = {
  login: () => import("../src/views/LoginWrap.vue"),
  mallHome: () => import("../src/views/mall/Home.vue"),
  mallExpertPurchaseHome: () => import("../src/views/mall/ExpertPurchaseHome.vue"),
  mallExpertPurchaseOrders: () => import("../src/views/mall/ExpertPurchaseOrderList.vue"),
  mallAllOrderList: () => import("../src/views/mall/OrderList/AllOrderList.vue"),
  mallAlibabaOrderListV2: () => import("../src/views/mall/OrderList/PlatformAllOrderListV2.vue"),
  mallRefundOrderList: () => import("../src/views/mall/OrderList/RefundOrderList.vue"),
  mallSelectOrderList: () => import("../src/views/mall/OrderList/SelectOrderList.vue"),
  mallWarehousePackage: () => import("../src/views/mall/OrderList/WarehousePackage.vue"),
  mallFavorites: () => import("../src/views/mall/favorites/index.vue"),
  mallBrowseHistory: () => import("../src/views/mall/history/index.vue"),
  mallAccount: () => import("../src/views/mall/account/index.vue"),
  mallMessage: () => import("../src/views/mall/message/index.vue"),
  mallNotices: () => import("../src/views/mall/notices/index.vue"),
  mallAllOrderDetail: () => import("../src/views/mall/OrderList/AllOrderDetail.vue"),
  mallTbOrderDetail: () => import("../src/views/mall/OrderList/TbOrderDetail.vue"),
  mallWeidianOrderDetail: () => import("../src/views/mall/OrderList/WeidianOrderDetail.vue"),
  mallUnifiedOrderDetail: () => import("../src/views/mall/OrderList/UnifiedOrderDetail.vue"),
  mallCart: () => import("../src/views/mall/Cart/CartList.vue"),
  mallConfirmation1688Order: () => import("../src/views/mall/Cart/Confirmation1688Order.vue"),
  mallConfirmationWeidianOrder: () => import("../src/views/mall/Cart/ConfirmationWeidianOrder.vue"),
  mallPay1688Order: () => import("../src/views/mall/Cart/Pay1688Order.vue"),
  mallPayWeidianOrder: () => import("../src/views/mall/Cart/PayWeidianOrder.vue"),
  mallTbDirectPaymentConfirm: () => import("../src/views/mall/Cart/TbDirectPaymentConfirm.vue"),
  mallTbPayOrder: () => import("../src/views/mall/Cart/TbPayOrder.vue"),
  mallRecharge: () => import("../src/views/mall/Recharge/index.vue"),
  mallGoldRecharge: () => import("../src/views/mall/Recharge/GoldRecharge.vue"),
  collectionMallPackage: () => import("../src/views/mall/collection/Package.vue"),
  collectionMyWarehouse: () => import("../src/views/mall/collection/MyWarehouse.vue"),
  collectionMyPackage: () => import("../src/views/mall/collection/MyPackage.vue"),
  collectionHome: () => import("../src/views/collection/Home.vue"),
  collectionOrder: () => import("../src/views/collection/Order.vue"),
  collectionPackage: () => import("../src/views/collection/Package.vue"),
  collectionForecast: () => import("../src/views/collection/Forecast.vue"),
  collectionNewCustomerTask: () => import("../src/views/collection/NewCustomerTaskCenter.vue"),
  collectionIncome: () => import("../src/views/collection/Income.vue"),
  collectionAddress: () => import("../src/views/collection/Address.vue"),
  collectionInvite: () => import("../src/views/collection/Invite.vue"),
  collectionFindLogistics: () => import("../src/views/collection/FindLogistics.vue"),
  collectionRechargeWallet: () => import("../src/views/mall/Recharge/index.vue"),
  collectionRecharge: () => import("../src/views/mall/Recharge/index.vue"),
  collectionCoupons: () => import("../src/views/collection/Coupons.vue"),
  collectionFeedback: () => import("../src/views/collection/Feedback.vue"),
  collectionPoints: () => import("../src/views/collection/Points.vue"),
  collectionPayOrder: () => import("../src/views/collection/PayOrder.vue"),
  collectionDeclaration: () => import("../src/views/collection/Declaration.vue"),
  collectionProxy: () => import("../src/views/collection/ProxyPc.vue"),
  collectionWithdrawCash: () => import("../src/views/collection/WithdrawCash.vue"),
  collectionReturnPackage: () => import("../src/views/collection/ReturnPackageList.vue"),
} satisfies Record<string, () => Promise<UserCenterViewModule>>;

export function getUserCenterViewLoader(viewKey = "") {
  return userCenterViewLoaders[viewKey as keyof typeof userCenterViewLoaders];
}
